<template>
  <div>
    <el-select
      v-model.number="_userId"
      class="mr-3"
      placeholder="選擇巡補員"
      clearable
      @clear="
        _userId = null;
        onSelect;
      "
      @change="onSelect"
    >
      <el-option v-for="item in users" :key="item.id" :label="item | formatUser" :value="item.id" />
    </el-select>
  </div>
</template>
<script>
import { getUserHasReplenish } from '@/api/user';
export default {
  props: ['companyId', 'userId'],
  filters: {
    formatUser(user) {
      return `${user.user_code} ${user.name}`;
    },
  },
  data() {
    return {
      users: [],
      selectUserId: null,
    };
  },
  computed: {
    _userId: {
      get() {
        return this.userId;
      },
      set(val) {
        this.$emit('update:userId', val);
      },
    },
  },
  watch: {
    async companyId() {
      this.users = await getUserHasReplenish({ company_id: this.companyId });
      this._userId = null;
      this.onSelect();
    },
  },

  async created() {
    this.$emit('onSelect');
    this.users = await getUserHasReplenish({ company_id: this.companyId });
  },
  methods: {
    onSelect() {
      this.$emit('onSelect');
    },
  },
};
</script>
